export enum ClaimStatusEnum {
  DocumentationPending = 1,
  BudgetPending = 2,
  AuthorizedPending = 3,
  UnderRepair = 4,
  ThirdParties = 5,
  Closed = 6,
  Cancelled = 7,
}